SC.suggestedseries = (function () {
  var api = {};

  var init = function () {
    handleEvents();
  };

  var addSeriesToBagForm = function addSeriesToBagForm($form) {
    var $productInfo = $form.find('.product-info');
    var seriesName = $productInfo.data('series-name');
    var productName = (seriesName === '1') ? 'A single class.' : 'A set of ' + seriesName + ' classes.';
    var baseSku = $productInfo.data('series-id');
    var sku = SC.utils.getSku('Series', baseSku, seriesName);
    var attrs = {'Base Sku': baseSku};
    var unitPrice = $productInfo.data('series-price');
    var product = SC.analytics.mp.createProduct(
      productName,
      sku,
      unitPrice,
      '1',
      null,
      attrs
    );

    SC.analytics.mp.setCurrencyCode($productInfo.data('currency-code'));
    SC.analytics.mp.logProductEvent('AddToCart', product, {'Location': 'New Rider'});

    $form.submit();
  };

  // Setup event handlers.
  var handleEvents = function () {
    var $seriesContainer = $('.js-suggested-series');

    $seriesContainer.on('mouseenter click keydown', '.more-info-icon', handleHoverInfo);
    $seriesContainer.on('mouseleave focusout', '.credits-additional-info', handleHoverInfo);
    $seriesContainer.on('click keydown', '.close-more-info', handleHoverInfo);

    $seriesContainer.on('keydown', '.credits-additional-info', function (e) {
      if (e.key !== 'Escape') {
        return;
      }

      var $tooltip = $(e.currentTarget);
      $tooltip.removeClass('block');
      $tooltip.siblings('.more-info-icon').focus();
    });

    $seriesContainer.on('click keydown', '.series-packs .form-button', function (e) {
      if (e.type === 'keydown' &&  e.key !== 'Enter') {
        return;
      }

      addSeriesToBagForm($(this).closest('form'));
    });

    // On mobile/tablet (<1024px), the form-button is hidden so the whole card is clickable
    $seriesContainer.on('click keydown', '.pack-card', function (e) {
      if (e.type === 'keydown' && e.key !== 'Enter') {
        return;
      }

      if (window.innerWidth >= 1024) {
        return;
      }

      if ($(e.target).closest('.credits-additional-info, .more-info-icon').length) {
        return;
      }

      addSeriesToBagForm($(this).find('.add-series-form'));
    });

    $('#suggested-series-cancel').on('click', function () {
      SC.analytics.mp.logEvent('Click No Thanks', 'navigation', {'Location': 'New Rider'});
    });

    $('#view-all-series-button').on('click', function () {
      SC.analytics.mp.logEvent('Click View All Series Options', 'navigation', {'Location': 'New Rider'});
    });
  };

  /**
   * Handles finding the event and target block for styling
   *
   * @param {object} e triggered event
   * @returns {void}
   */
  var handleHoverInfo = function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter') {
      return;
    }

    e.stopPropagation();

    var $this = $(e.currentTarget);

    // Set the default params on click and override in the switch
    var target = $this.parent('.credits-additional-info');
    var status = 'hide';
    // if the type is click/keydown and the current target is the more info icon (accessibility enter key)
    var activateClick = (e.type === 'click' || e.type === 'keydown') && e.currentTarget.classList.contains('more-info-icon');

    if (e.type === 'mouseenter' || activateClick ) {
      if (e.currentTarget.classList.contains('more-info-icon')) {
        target = $this.siblings('.credits-additional-info');
        status = 'show';
      }
    } else if (e.type === 'mouseleave' || e.type === 'focusout') {
      if (e.type === 'focusout' && $(e.currentTarget).has(e.relatedTarget).length) {
        return;
      }

      target = $this;
    }

    showToolTip(target, status);
  };

  /**
   * Assigns and removes block styling for hover of tool tip
   *
   * @param {object} target dom element
   * @param {string} status show or not
   * @returns {void}
   */
  var showToolTip = function (target, status) {
    if (status === 'show') {
      target.addClass('block');
      target.find('.close-more-info').focus();
    } else {
      target.removeClass('block');
      target.siblings('.more-info-icon').focus();
    }
  };

  init();

  return api;
})();
